// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-window .MuiDialog-paper {
    border-radius: 20px;
}
.modal-window__content {
    padding: 3.2rem 1.6rem;
}
@media screen and (min-width: 480px) {
    .modal-window__content {
        padding: 3.2rem;
    }
}

.modal-window__title h2 {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
}
.MuiIconButton-root.modal-window__close-btn {
    font-size: 1rem;
}
.modal-items {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px;
}

.modal-items__notification-text {
    font-size: 1.3125rem;
    font-weight: 600;
    text-align: center;
}

.modal-window .modal-window__title h2 {
    font-size: 1.3125rem;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-window .MuiDialog-paper {
    max-width: 340px;
}

.modal-window .MuiDialogTitle-root {
    padding: 16px 24px 0;
}

.modal-items__action-btns {
    padding: 31px 0 15px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    column-gap: 8px;
}
.modal-item__action-btn.MuiButton-text {
    border-radius: 150px;
    font-weight: 600;
    line-height: 18px;
    width: 100%;
    padding: 11px 16px;
}
.modal-items__input-field {
    width: 100%;
}

.modal-item__action-btn--primary.MuiButton-text {
    background-color: var(--app-fill-color-primary-one);
    color: var(--app-primary-bg-color-white);
}
`, "",{"version":3,"sources":["webpack://./src/core/components/modalsPortalsNotices/ModalWindow/styles/ModalWindow.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;;AAEA;IACI,mDAAmD;IACnD,wCAAwC;AAC5C","sourcesContent":[".modal-window .MuiDialog-paper {\n    border-radius: 20px;\n}\n.modal-window__content {\n    padding: 3.2rem 1.6rem;\n}\n@media screen and (min-width: 480px) {\n    .modal-window__content {\n        padding: 3.2rem;\n    }\n}\n\n.modal-window__title h2 {\n    display: flex;\n    justify-content: space-between;\n    padding: 0 10px;\n}\n.MuiIconButton-root.modal-window__close-btn {\n    font-size: 1rem;\n}\n.modal-items {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 16px;\n}\n\n.modal-items__notification-text {\n    font-size: 1.3125rem;\n    font-weight: 600;\n    text-align: center;\n}\n\n.modal-window .modal-window__title h2 {\n    font-size: 1.3125rem;\n    font-weight: 600;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.modal-window .MuiDialog-paper {\n    max-width: 340px;\n}\n\n.modal-window .MuiDialogTitle-root {\n    padding: 16px 24px 0;\n}\n\n.modal-items__action-btns {\n    padding: 31px 0 15px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    column-gap: 8px;\n}\n.modal-item__action-btn.MuiButton-text {\n    border-radius: 150px;\n    font-weight: 600;\n    line-height: 18px;\n    width: 100%;\n    padding: 11px 16px;\n}\n.modal-items__input-field {\n    width: 100%;\n}\n\n.modal-item__action-btn--primary.MuiButton-text {\n    background-color: var(--app-fill-color-primary-one);\n    color: var(--app-primary-bg-color-white);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
